<template>
    <!-- header (Zain Blue Style) -->
    <header class="zain-header">
        <div class="zain-header__container">
            <!-- Left Section: Zain Logo + Buttons -->
            <div class="zain-header__left">
                <router-link to="/" class="zain-header__logo">
                    <img src="../../assets/image/logoSvg.svg" alt="Zain" class="zain-logo-img">
                </router-link>

                <div class="zain-header__buttons">
                    <template v-if="!showHeader">
                        <router-link to="/signin" class="zain-btn zain-btn--filled">
                            <span>الدخول</span>
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                                <path d="M19 12H5M12 19l-7-7 7-7"/>
                            </svg>
                        </router-link>
                        <router-link to="/Subscribes" class="zain-btn zain-btn--outline">
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                                <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/>
                                <circle cx="12" cy="7" r="4"/>
                            </svg>
                            <span>الاشتراك</span>
                        </router-link>
                    </template>
                    <template v-else>
                        <router-link to="/profile" class="zain-btn zain-btn--filled">
                            <span>الملف الشخصي</span>
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                                <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/>
                                <circle cx="12" cy="7" r="4"/>
                            </svg>
                        </router-link>
                        <router-link to="/Unsubscribes" class="zain-btn zain-btn--outline">
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                                <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"/>
                                <polyline points="16 17 21 12 16 7"/>
                                <line x1="21" y1="12" x2="9" y2="12"/>
                            </svg>
                            <span>إلغاء الاشتراك</span>
                        </router-link>
                    </template>
                </div>
            </div>

            <!-- Center Section: Search Bar -->
            <div class="zain-header__center">
                <form class="zain-search" @submit.prevent="SearchData()">
                    <input
                        type="text"
                        v-model="search"
                        class="zain-search__input"
                        placeholder="بحث عن العناء..."
                    >
                    <button type="submit" class="zain-search__btn">
                        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                            <circle cx="11" cy="11" r="8"/>
                            <path d="M21 21l-4.35-4.35"/>
                        </svg>
                    </button>
                </form>
            </div>

            <!-- Right Section: App Logo + Nav + Decorative Shapes -->
            <div class="zain-header__right">
                <router-link to="/" class="zain-header__app-logo">
                    <span class="app-logo-text">إضبط وزنك</span>
                </router-link>

                <!-- Categories Navigation -->
                <nav class="zain-header__nav">
                    <router-link to="/" class="zain-nav__link">
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                            <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/>
                            <polyline points="9 22 9 12 15 12 15 22"/>
                        </svg>
                        <span>الرئيسية</span>
                    </router-link>
                    <div class="zain-nav__dropdown" @mouseenter="showCatDropdown = true" @mouseleave="showCatDropdown = false">
                        <a href="#" class="zain-nav__link" @click.prevent>
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                                <rect x="3" y="3" width="7" height="7"/>
                                <rect x="14" y="3" width="7" height="7"/>
                                <rect x="14" y="14" width="7" height="7"/>
                                <rect x="3" y="14" width="7" height="7"/>
                            </svg>
                            <span>الفئات</span>
                            <svg class="dropdown-arrow" xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                                <polyline points="6 9 12 15 18 9"/>
                            </svg>
                        </a>
                        <ul class="zain-nav__dropdown-menu" :class="{ 'is-open': showCatDropdown }">
                            <li v-for="cat in categoris" :key="cat.id">
                                <router-link :to="{ name: 'Categorys', params: { catid: cat.id } }">
                                    {{ cat.name_ar }}
                                </router-link>
                            </li>
                        </ul>
                    </div>
                </nav>
            </div>

            <!-- Mobile Menu Button -->
            <button class="zain-header__menu-btn" type="button" @click="toggleMobileMenu">
                <span></span>
                <span></span>
                <span></span>
            </button>
        </div>

        <!-- Mobile Navigation -->
        <nav class="zain-mobile-nav" :class="{ 'is-open': mobileMenuOpen }">
            <router-link to="/" class="zain-mobile-nav__link" @click="closeMobileMenu">
                الصفحة الرئيسية
            </router-link>
            <div class="zain-mobile-nav__dropdown">
                <a href="#" class="zain-mobile-nav__link" @click.prevent="toggleCategories">
                    الفئات
                    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                        <polyline points="6 9 12 15 18 9"/>
                    </svg>
                </a>
                <ul class="zain-mobile-nav__submenu" :class="{ 'is-open': categoriesOpen }">
                    <li v-for="cat in categoris" :key="cat.id">
                        <router-link :to="{ name: 'Categorys', params: { catid: cat.id } }" @click="closeMobileMenu">
                            {{ cat.name_ar }}
                        </router-link>
                    </li>
                </ul>
            </div>
            <template v-if="showHeader">
                <router-link to="/contacts" class="zain-mobile-nav__link" @click="closeMobileMenu">
                    اتصل بنا
                </router-link>
                <router-link to="/profile" class="zain-mobile-nav__link" @click="closeMobileMenu">
                    الملف الشخصي
                </router-link>
                <router-link to="/Unsubscribes" class="zain-mobile-nav__link" @click="closeMobileMenu">
                    إلغاء الاشتراك
                </router-link>
            </template>
            <template v-else>
                <router-link to="/signin" class="zain-mobile-nav__link" @click="closeMobileMenu">
                    تسجيل دخول
                </router-link>
                <router-link to="/Subscribes" class="zain-mobile-nav__link" @click="closeMobileMenu">
                    إشترك الآن
                </router-link>
            </template>
        </nav>
    </header>
    <!-- end header -->
</template>

<script>
import { ref } from '@vue/reactivity';
import { onMounted, watchEffect } from '@vue/runtime-core';
import { HTTPDSP } from '@/Api/http-dsp';
import { HTTP } from '@/Api/http-common';
import { useRoute, useRouter } from 'vue-router';
import { useCookie } from 'vue-cookie-next'
export default {
    name: 'AppHeader',
    setup() {
        const router = useRouter();
        const route = useRoute();
        const cookie = useCookie()
        const showHeader = ref(true);
        const search = ref([]);
        const categoris = ref([]);
        const mobileMenuOpen = ref(false);
        const categoriesOpen = ref(false);
        const showCatDropdown = ref(false);

        const toggleMobileMenu = () => {
            mobileMenuOpen.value = !mobileMenuOpen.value;
            if (!mobileMenuOpen.value) {
                categoriesOpen.value = false;
            }
        };

        const closeMobileMenu = () => {
            mobileMenuOpen.value = false;
            categoriesOpen.value = false;
        };

        const toggleCategories = () => {
            categoriesOpen.value = !categoriesOpen.value;
        };

        watchEffect(async () => {
            if (cookie.isCookieAvailable('msisdn')) {

                showHeader.value = true;

                try {
                    const response = await HTTPDSP.get(`DSPCheckLogin.php?msisdn=${cookie.getCookie("msisdn")}`);

                    const status = response.data?.status;
                    const message = response.data?.message || "Unknown error";

                    if (status == 1 && message == "Successful") {
                        console.log("User is logged in and subscribed.");
                        return { status: "subscribed" };

                    } else if (status == 0 && message == "Subscribed but not active") {
                        cookie.removeCookie('status');
                        cookie.removeCookie('minutes');
                        return { status: "Subscribed_but_not_active" };
                    } else if (status == 0 && message == "Not subscribed") {
                        cookie.removeCookie('msisdn');
                        cookie.removeCookie('status');
                        cookie.removeCookie('minutes');
                        return { status: "not_subscribed" };
                    } else {
                        console.warn("Unexpected status or message:", response.data);
                        cookie.removeCookie('msisdn');
                        cookie.removeCookie('status');
                        cookie.removeCookie('minutes');
                        return { status: "unexpected_status", message };
                    }

                } catch (error) {
                    console.error('Error checking subscription:', error);
                }
            } else {
                showHeader.value = false;
            }
        });

        const GetCategories = async () => {
            await HTTP.get('GetAllCategories.php').then(res => {
                categoris.value = res.data.Categories;
            })
        }
        onMounted(() => {
            GetCategories();

            const s = document.createElement('script');
            s.type = 'text/javascript';
            s.src = '/static/js/main.js';
            document.body.appendChild(s);
        });

        const SearchData = () => {
            router.push({ name: "Searchs", params: { search_id: search.value } });
        }
        return {
            search,
            categoris,
            showHeader,
            SearchData,
            mobileMenuOpen,
            categoriesOpen,
            showCatDropdown,
            toggleMobileMenu,
            closeMobileMenu,
            toggleCategories
        };
    },
}
</script>

<style scoped>
/* Zain Header Styles */
.zain-header {
    /* background: linear-gradient(135deg, #006D6D 0%, #008B8B 30%, #00A5A5 60%, #00B8B8 100%); */
    background: linear-gradient(135deg, #034635 0%, #0d6650 30%, #309d81 60%, #214d42 100%);
    padding: 0;
    position: relative;
    overflow: visible;
    min-height: 70px;
    z-index: 1000;
}

.zain-header__container {
    display: flex;
    align-items: center;
    justify-content: space-between;
    max-width: 1400px;
    margin: 0 auto;
    padding: 12px 20px;
    position: relative;
    z-index: 2;
    direction: ltr;
}

/* Left Section */
.zain-header__left {
    display: flex;
    align-items: center;
    gap: 20px;
}

.zain-header__logo {
    display: flex;
    align-items: center;
}

.zain-logo-img {
    height: 40px;
    width: auto;
}

.zain-header__buttons {
    display: flex;
    align-items: center;
    gap: 10px;
    direction: rtl;
}

/* Navigation */
.zain-header__nav {
    display: flex;
    align-items: center;
    gap: 5px;
    margin-right: 15px;
    direction: rtl;
}

.zain-nav__link {
    display: flex;
    align-items: center;
    gap: 6px;
    padding: 8px 14px;
    color: #fff;
    text-decoration: none;
    font-size: 14px;
    font-weight: 500;
    border-radius: 20px;
    transition: all 0.3s ease;
}

.zain-nav__link:hover {
    background-color: rgba(255, 255, 255, 0.15);
    color: #fff;
}

.zain-nav__dropdown {
    position: relative;
}

.dropdown-arrow {
    transition: transform 0.3s ease;
}

.zain-nav__dropdown:hover .dropdown-arrow {
    transform: rotate(180deg);
}

.zain-nav__dropdown-menu {
    position: absolute;
    top: 100%;
    right: 0;
    min-width: 180px;
    background: rgba(0, 70, 70, 0.95);
    backdrop-filter: blur(10px);
    border-radius: 12px;
    padding: 8px 0;
    margin-top: 8px;
    list-style: none;
    opacity: 0;
    visibility: hidden;
    transform: translateY(-10px);
    transition: all 0.3s ease;
    box-shadow: 0 10px 40px rgba(0, 0, 0, 0.3);
    z-index: 1000;
}

.zain-nav__dropdown-menu.is-open {
    opacity: 1;
    visibility: visible;
    transform: translateY(0);
}

.zain-nav__dropdown-menu li a {
    display: block;
    padding: 10px 20px;
    color: rgba(255, 255, 255, 0.9);
    text-decoration: none;
    font-size: 14px;
    transition: all 0.2s ease;
    text-align: right;
}

.zain-nav__dropdown-menu li a:hover {
    background-color: rgba(79, 209, 197, 0.2);
    color: #4FD1C5;
}

/* Buttons */
.zain-btn {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    padding: 8px 20px;
    border-radius: 25px;
    font-size: 14px;
    font-weight: 500;
    text-decoration: none;
    transition: all 0.3s ease;
    cursor: pointer;
    white-space: nowrap;
}

.zain-btn--filled {
    background-color: rgba(255, 255, 255, 0.95);
    color: #006D6D;
    border: 2px solid transparent;
}

.zain-btn--filled:hover {
    background-color: #fff;
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.zain-btn--outline {
    background-color: transparent;
    color: #fff;
    border: 2px solid rgba(255, 255, 255, 0.8);
}

.zain-btn--outline:hover {
    background-color: rgba(255, 255, 255, 0.1);
    border-color: #fff;
    transform: translateY(-2px);
}

/* Center Section - Search */
.zain-header__center {
    flex: 1;
    max-width: 400px;
    margin: 0 30px;
}

.zain-search {
    display: flex;
    align-items: center;
    background-color: rgba(0, 40, 40, 0.6);
    border-radius: 25px;
    padding: 4px;
    border: 1px solid rgba(255, 255, 255, 0.1);
    direction: rtl;
}

.zain-search__input {
    flex: 1;
    background: transparent;
    border: none;
    outline: none;
    padding: 10px 16px;
    color: #fff;
    font-size: 14px;
    text-align: right;
}

.zain-search__input::placeholder {
    color: rgba(255, 255, 255, 0.5);
}

.zain-search__btn {
    background: transparent;
    border: none;
    padding: 8px 12px;
    cursor: pointer;
    color: rgba(255, 255, 255, 0.7);
    display: flex;
    align-items: center;
    justify-content: center;
    transition: color 0.3s ease;
}

.zain-search__btn:hover {
    color: #fff;
}

/* Right Section */
.zain-header__right {
    display: flex;
    align-items: center;
    gap: 15px;
    position: relative;
    direction: rtl;
}

.zain-header__app-logo {
    text-decoration: none;
}

.app-logo-text {
    font-size: 24px;
    font-weight: 700;
    color: #FFF;
    text-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    letter-spacing: 1px;
}


.shape {
    position: absolute;
    background-color: rgba(79, 209, 197, 0.4);
    clip-path: polygon(50% 0%, 100% 38%, 82% 100%, 18% 100%, 0% 38%);
}

.shape--1 {
    width: 70px;
    height: 70px;
    left: -20px;
    top: -15px;
    opacity: 0.7;
}

.shape--2 {
    width: 50px;
    height: 50px;
    left: 30px;
    top: 25px;
    opacity: 0.5;
}

.shape--3 {
    width: 40px;
    height: 40px;
    left: 70px;
    top: -5px;
    opacity: 0.6;
}

/* Mobile Menu Button */
.zain-header__menu-btn {
    display: none;
    flex-direction: column;
    justify-content: space-between;
    width: 28px;
    height: 20px;
    background: transparent;
    border: none;
    cursor: pointer;
    padding: 0;
}

.zain-header__menu-btn span {
    display: block;
    width: 100%;
    height: 3px;
    background-color: #fff;
    border-radius: 2px;
    transition: all 0.3s ease;
}

/* Mobile Navigation */
.zain-mobile-nav {
    display: none;
    flex-direction: column;
    background: rgba(0, 60, 60, 0.95);
    padding: 0;
    max-height: 0;
    overflow: hidden;
    transition: max-height 0.3s ease, padding 0.3s ease;
}

.zain-mobile-nav.is-open {
    max-height: 500px;
    padding: 15px 20px;
}

.zain-mobile-nav__link {
    display: flex;
    align-items: center;
    justify-content: space-between;
    color: #fff;
    text-decoration: none;
    padding: 12px 0;
    border-bottom: 1px solid rgba(255, 255, 255, 0.1);
    font-size: 15px;
    transition: color 0.3s ease;
}

.zain-mobile-nav__link:hover {
    color: #4FD1C5;
}

.zain-mobile-nav__dropdown {
    position: relative;
}

.zain-mobile-nav__submenu {
    list-style: none;
    padding: 0;
    margin: 0;
    max-height: 0;
    overflow: hidden;
    transition: max-height 0.3s ease;
    background: rgba(0, 40, 40, 0.5);
}

.zain-mobile-nav__submenu.is-open {
    max-height: 300px;
}

.zain-mobile-nav__submenu li a {
    display: block;
    color: rgba(255, 255, 255, 0.8);
    text-decoration: none;
    padding: 10px 20px;
    font-size: 14px;
    transition: all 0.3s ease;
}

.zain-mobile-nav__submenu li a:hover {
    color: #4FD1C5;
    background: rgba(255, 255, 255, 0.05);
}

/* Responsive Styles */
@media (max-width: 992px) {
    .zain-header__center {
        max-width: 280px;
        margin: 0 15px;
    }

    .zain-header__buttons {
        gap: 8px;
    }

    .zain-btn {
        padding: 6px 14px;
        font-size: 13px;
    }

    .app-logo-text {
        font-size: 20px;
    }
}

@media (max-width: 992px) {
    .zain-header__nav {
        display: none;
    }
}

@media (max-width: 768px) {
    .zain-header__container {
        padding: 15px 15px;
    }

    .zain-header__buttons,
    .zain-header__center,
    .zain-header__right,
    .zain-header__nav {
        display: none;
    }

    .zain-header__menu-btn {
        display: flex;
    }

    .zain-mobile-nav {
        display: flex;
    }

    .zain-logo-img {
        height: 32px;
    }
}

/* Animation for shapes */
@keyframes float {
    0%, 100% {
        transform: translateY(0);
    }
    50% {
        transform: translateY(-5px);
    }
}

.shape--1 {
    animation: float 3s ease-in-out infinite;
}

.shape--2 {
    animation: float 3s ease-in-out infinite 0.5s;
}

.shape--3 {
    animation: float 3s ease-in-out infinite 1s;
}
</style>
